<template>
    <div class="skeleton-narrow">
        <div class="top-row">
            <div class="like"/>
            <div class="share"/>
            <div class="more"/>
            <div class="expanded"/>
            <div class="download"/>
        </div>
        <div class="img"/>
        <div class="separator"/>
        <div class="user-row">
            <div class="icon"/>
            <div class="name"/>
        </div>
        <div class="title"/>
        <div class="prompt"/>
        <div class="action"/>
        <div class="separator"/>
        <div class="keywords">
            <div v-for="(item, index) of keywords" :key="index" class="item" :class="[item]"/>
        </div>
        <skeleton-grid-view/>
    </div>
</template>

<script setup>
const keywords = ['k1', 'k2', 'k3', 'k4', 'k5', 'k6', 'k7', 'k8', 'k9'];
</script>

<style scoped lang="scss">
.skeleton-narrow {
    width: calc(100% - 48px);
    margin: auto;
    .top-row {
            height: 82px;
            width: 100%;
            display: flex;
            align-items: center;
    
            .like {
                width: 100px;
                height: 44px;
                background: #f4f5f6;
                border-radius: 10px;
            }
    
            .share {
                margin-left: 15px;
                width: 44px;
                height: 44px;
                background: #f4f5f6;
                border-radius: 10px;
            }
    
            .more {
                margin-left: 15px;
                width: 44px;
                height: 44px;
                background: #f4f5f6;
                border-radius: 10px;
            }
    
            .expanded {
                flex: 1;
            }
    
            .download {
                width: 44px;
                height: 44px;
                background: #f4f5f6;
                border-radius: 10px;
            }
        }
    
        .img {
            width: 100%;
            aspect-ratio: 346 / 285;
            background: #f4f5f6;
            border-radius: 10px;
            margin-bottom: 18px;
        }
    
        .separator {
            width: 100%;
            height: 1px;
            background: #f4f5f6;
        }
    
        .user-row {
            margin-top: 20px;
            margin-bottom: 12px;
            display: flex;
            align-items: start;
    
            .icon {
                width: 47px;
                height: 47px;
                border-radius: 50%;
                background: #f4f5f6;
            }
    
            .name {
                width: 158px;
                height: 20px;
                background: #f4f5f6;
                border-radius: 5px;
                margin-left: 4px;
            }
        }
    
        .title {
            width: 157px;
            height: 30px;
            background: #f4f5f6;
            border-radius: 10px;
        }
    
        .prompt {
            margin-top: 11px;
            width: 100%;
            height: 196px;
            background: #f4f5f6;
            border-radius: 10px;
            margin-bottom: 12px;
        }
    
        .action {
            width: 100%;
            height: 44px;
            background: #f4f5f6;
            border-radius: 10px;
            margin-bottom: 26px;
        }
    
        .keywords {
            margin-top: 20px;
            display: flex;
            margin-bottom: 20px;
            width: 100%;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
    
            .item {
                flex-shrink: 0;
                white-space: nowrap;
                height: 41px;
                background: #f4f5f6;
                border-radius: 10px;
                margin-left: 12px;
    
                &:first-child {
                    margin-left: 0px;
                }
    
                &.k1 {
                    width: 124px;
                }
    
                &.k2 {
                    width: 90px;
                }
    
                &.k3 {
                    width: 110px;
                }
    
                &.k4 {
                    width: 78px;
                }
    
                &.k5 {
                    width: 72px;
                }
    
                &.k6 {
                    width: 209px;
                }
    
                &.k7 {
                    width: 116px;
                }
    
                &.k8 {
                    width: 87px;
                }
    
                &.k9 {
                    width: 100px;
                }
            }
        }
}
</style>
